module.exports = __webpack_public_path__ + "static/media/enterprise-logo.a1106b57.svg";